addEventListener('DOMContentLoaded', () => {

	// Calculate Return Date	
	window.return_date = function return_date(return_days = 30, el = 'return-date') {
      
		let return_date;
        var return_date_div = document.querySelector('.' + el);

		var thirty_days_later = new Date();
		thirty_days_later.setDate(thirty_days_later.getDate() + return_days);
		thirty_days_later = thirty_days_later.toDateString();

		let day = thirty_days_later.split(" ")[2];
		let month = thirty_days_later.split(" ")[1];
		let year = thirty_days_later.split(" ")[3];
		return_date = month + " " + day + ", " + year;

        return_date_div.innerHTML = " until " + return_date;

	}
    return_date();

	// Calculate Order Cutoff
	function order_cutoff() {
		let cutoff_hour = 14;
		let cutoff_mins = 0;
		let cutoff_time = (cutoff_hour > 9 ? cutoff_hour : "0" + cutoff_hour) + ":" + (cutoff_mins > 9 ? cutoff_mins : "0" + cutoff_mins);

		let d1 = new Date();
		let d2 = new Date();

		// get day number
		let day = d1.getDay();

		let deadline_label;

		if (day == 0 || day == 6 || (day == 5 && d1.getHours() >= cutoff_hour && d1.getMinutes() >= cutoff_mins)) {
			deadline_label = "Order by <span class='text-success'>Monday 12pm (EST)</span>";

		} else {
			d2 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate() + (d1.getHours() >= cutoff_hour ? 1 : 0), cutoff_hour, cutoff_mins, 0);

			let diff = d2.getTime() - d1.getTime();
			let hours = Math.floor(diff / 1000 / 60 / 60);
			let mins = Math.floor(diff / 1000 / 60) - hours * 60;

			hours = hours > 0 ? hours + " hours " : "";
			mins = mins > 0 ? mins + " mins " : "";

			let span_class;
			span_class = (hours == 0 ? "danger blink" : "success");
			deadline_label = 'Order within <span class="text-' + span_class + '"">' + hours + mins + "</span>";

			clog(d1 + " -- " + d2);
		}

		return deadline_label;
	}

	// Print Order Cutoff
	var order_cutoff_div = document.getElementById('order_cutoff');
	order_cutoff_div.innerHTML = order_cutoff();


	// Get ZIP Code
	var zip_code = document.querySelector('.postal-div');
	zip_code.onclick = function () {
		var new_zip = prompt('Please enter your zip code to check if we ship to your area', '');
		if (new_zip.length == 5 && new_zip.match(/^\d+$/)) {
			//
		}
	}

});